"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grizzana-morandi": {
    "79043fba": [{
      "hkey": "d0134ee6",
      "slug": "poggio-di-carviano",
      "name": "Poggio di Carviano",
      "primary": true,
      "skipSearch": false
    }],
    "carviano": [{
      "hkey": "d0134ee6",
      "slug": "poggio-di-carviano",
      "name": "Poggio di Carviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8d2de887": [{
      "hkey": "76542576",
      "slug": "grizzana-morandi",
      "name": "Grizzana Morandi",
      "primary": true,
      "skipSearch": false
    }],
    "prada": [{
      "hkey": "76542576",
      "slug": "grizzana-morandi",
      "name": "Grizzana Morandi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0a93412": [{
      "hkey": "ac385e8b",
      "slug": "pioppe-di-salvaro",
      "name": "Pioppe di Salvaro",
      "primary": true,
      "skipSearch": false
    }],
    "salvaro": [{
      "hkey": "ac385e8b",
      "slug": "pioppe-di-salvaro",
      "name": "Pioppe di Salvaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d05cc22e": [{
      "hkey": "76542576",
      "slug": "grizzana-morandi",
      "name": "Grizzana Morandi",
      "primary": true,
      "skipSearch": false
    }],
    "tavernola": [{
      "hkey": "76542576",
      "slug": "grizzana-morandi",
      "name": "Grizzana Morandi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;